import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

const initState = Map({
  data: {
    plan: 0
  },
  ticket: {},
  loading: true
});

export const { getMarketingStatus, getTicketStatus, setLoading } = createActions({
  getMarketingStatus: result => {
    return result;
  },
  getTicketStatus: result => result,
  setLoading: result => result
});

const marketingStatus = handleActions(
  {
    [getMarketingStatus]: (state, action) => {
      return state.set('data', action.payload);
    },
    [getTicketStatus]: (state, action) => {
      return state.set('ticket', action.payload);
    },
    [setLoading]: (state, action) => {
      return state.set('loading', action.payload);
    }
  },
  initState
);

export default marketingStatus;
